import {Controller} from "stimulus";

type TrixEditorElement = HTMLElement & {editor: {loadHTML: (html: string) => void}};

export default class PrefillRichTextController extends Controller {
  static targets = ["editor"];
  static values = {html: String};

  declare htmlValue: string;
  declare editorTarget: TrixEditorElement;

  prefill() {
    this.editorTarget.editor.loadHTML(this.htmlValue);
  }
}
